import styled from 'styled-components';

import { colors } from 'theme/theme';

export const StaffPageHeaderSeparator = styled.div`
  width: 1px;
  height: 20px;
  background: ${colors.elementGrey};
  opacity: 0.5;
`;
